export const mapServiceUrls = {
    mapLayerFungus: './services/fungus/fungus_net_art/MapServer/',
    mapLayerLichen: './services/lichen/lichen_net_art/MapServer/'
}

let restUrl = process.env.BASE_URL + 'rest/'
let species = restUrl + 'species/'
let diagram = restUrl + 'diagram/'
let config = restUrl + 'config/'

export const configUrl = {
    config: config + 'app/',
}

export const speciesUrl = {
    speciesByName: species + 'byName/',
    speciesNamesByTaxon: species + 'namesByTaxon/',
    speciesObservation: species + 'observations?',
    observationFirst: species + 'observations/first/',
    observationLast: species + 'observations/last/',
    observationLowest: species + 'observations/lowest/',
    observationHighest: species + 'observations/highest/',
    observationCount: species + 'observations/count/',
    observationSelected: species + 'observations/countSelected/',
    speciesImages: species + 'images/',
    protectionFungus: species + 'protectionFungus/',
    protectionLichen: species + 'protectionLichen/',
    dataBasisFungus: species + 'dataBasisFungus/',
    dataBasisLichen: species + 'dataBasisLichen/',
    isNeomycete: species + 'isNeomycete/',
    higherTaxonomyByGenus: species + 'higherTaxonomy/byGenus/',
    indexFungorumInfo: species + 'indexFungorum/'
}

export const diagramUrl = {
    diagramByMonth: diagram + 'observations/byMonth/',
    diagramByAltitude: diagram + 'observations/byAltitude/',
    diagramBySubstrateCoarse: diagram + 'observations/bySubstrateCoarse/',
    diagramBySubstrateFine: diagram + 'observations/bySubstrateFine/',
    diagramByEcotype: diagram + 'observations/byEcotype/',
    diagramByHostPlant: diagram + 'observations/byHostPlant/',
    diagramByHostFungus: diagram + 'observations/byHostFungus/',
    diagramByWoodQuality: diagram + 'observations/byWoodQuality/',
    diagramByWoodDistinction: diagram + 'observations/byWoodDistinction/',
    diagramByMykoPartner: diagram + 'observations/byMykoPartner/',
    diagramByDelarze: diagram + 'observations/byDelarze/',
    // diagramByDelarzeMini: diagram + 'observations/byDelarzeMini/',
    diagramBySubstrate: diagram + 'bySubstrate/'
}

export const indexFungorumAPI = {
    searchNameByID: 'http://www.indexfungorum.org/Names/NamesRecord.asp?RecordID='
}